import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
const Layout: React.FC = () => {
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-200" data-id="element-22">
      <main className="pb-20" data-id="element-23">
        <Outlet data-id="element-24" />
      </main>
      <Navigation data-id="element-25" />
    </div>;
};
export default Layout;